<!--This component is the text which displays plan version on top of a participant card
 Used in SelectPlanVersion and WalkInPlanVersion-->
<template>
	<span class="flex items-center gap-1 text-xs text-slate-500 italic">
		{{ pretext }}
		<span :class="{ 'text-primary-500': !isWalkIn }">
			{{ planVersionText }}
		</span>
		<ClockIcon
			class="inline size-4"
			:class="{ 'text-primary-500': !isWalkIn }"
		/>
	</span>
</template>

<script setup lang="ts">
import type { PlanOption } from '@/types'
import { ClockIcon } from '@heroicons/vue/24/outline'
import { computed, type PropType } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
	selectedPlanOption: {
		type: Object as PropType<PlanOption>,
		required: true,
	},
	isWalkIn: {
		type: Boolean,
		default: false,
	},
})

const historyExists = computed(() => !!props.selectedPlanOption?.lastUpdated)

const pretext = computed(() => {
	return historyExists.value
		? t('newSession.continueFrom')
		: t('newSession.startingNew')
})

const planVersionText = computed(() => {
	return historyExists.value
		? t('newSession.planLastUpdated', {
				fullName: props.selectedPlanOption?.fullName,
				date: props.selectedPlanOption?.formattedDate,
			})
		: props.selectedPlanOption?.fullName
})
</script>
